module.exports = __webpack_public_path__ + "media/images/user/lp/mv/desktop-81051b7e4acad0a59a5a0f6514c7d059.png";